module.exports = __webpack_public_path__ + "img/lianxi.1f89ab5b.png";